import { NavLink, Outlet, Link } from "react-router-dom";
import { Layers, Image as ImageIcon, ArrowLeft, History, Eye, HelpCircle, Palette } from "lucide-react";
import WelcomeTour from "./WelcomeTour";

const items = [
  { to: "/editor",        label: "Pages",      icon: Layers,    end: true },
  { to: "/editor/media",  label: "Media",      icon: ImageIcon },
];

export default function EditorLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 font-semibold" data-testid="editor-back-to-site">
              <ArrowLeft size={16}/> Back to site
            </Link>
            <span className="text-slate-300">/</span>
            <h1 className="font-fredoka text-xl sm:text-2xl font-bold text-slate-900">Website Editor</h1>
            <span className="hidden sm:inline-flex text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 border border-amber-200">CMS</span>
          </div>
          <a href="/" target="_blank" rel="noreferrer" className="text-xs font-semibold text-slate-600 hover:text-slate-900 inline-flex items-center gap-1" data-testid="editor-open-site">
            <Eye size={14}/> Open live site
          </a>
        </div>

        <div className="grid lg:grid-cols-[220px_1fr] gap-5">
          <aside className="lg:sticky lg:top-4 lg:self-start">
            <nav className="card-clay p-2 space-y-1" data-testid="editor-sidebar">
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.end}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold transition ${
                      isActive
                        ? "bg-slate-900 text-white"
                        : "text-slate-700 hover:bg-slate-100"
                    }`
                  }
                  data-testid={`editor-nav-${it.label.toLowerCase()}`}
                >
                  <it.icon size={16}/> {it.label}
                </NavLink>
              ))}
              <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-slate-400 mt-2">Helpful</div>
              <button
                onClick={() => window.dispatchEvent(new Event("bd:open-editor-tour"))}
                className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-xs text-slate-600 hover:bg-slate-100"
                data-testid="editor-show-tour"
              >
                <HelpCircle size={14}/> Show welcome tour
              </button>
              <button
                onClick={() => {
                  const ev = new Event("bd:open-editor-tour");
                  window.dispatchEvent(ev);
                  // The tour starts at step 0; users can click Next 5 times to reach Brand
                }}
                className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-xs text-slate-600 hover:bg-slate-100"
                data-testid="editor-show-brand"
              >
                <Palette size={14}/> Brand colors & fonts
              </button>
              <a href="/policies" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs text-slate-500 hover:bg-slate-100">
                <History size={14}/> See live policies
              </a>
            </nav>
            <div className="card-clay p-3 mt-3 bg-amber-50 border-amber-200">
              <div className="text-xs font-bold text-amber-900">Tip</div>
              <p className="text-[11px] text-amber-800 mt-1 leading-relaxed">
                Edits go to <b>Draft</b> first. Click <b>Publish</b> to push them live. Each publish is saved as a revision you can restore.
              </p>
            </div>
          </aside>

          <section className="min-w-0">
            <Outlet />
          </section>
        </div>
      </div>
      <WelcomeTour />
    </div>
  );
}
